import type { GetPaymentsNewResponse } from '@vy/api-definition';
import { getPrivateApi } from '../services/api';

export type GetPaymentsNewParams = {
  page: number;
  pageSize: number;
  search?: string;
  paymentFilters?: string;
  sort?: string;
};

const apiClient = {
  get: async <T>(url: string, config?: { params?: Record<string, unknown> }): Promise<{ data: T }> => {
    const api = getPrivateApi();

    if (url === '/payments/overviews-new') {
      const response = await api.getPaymentsNew(config?.params || {});
      return { data: response as T };
    }

    throw new Error(`Unsupported URL: ${url}`);
  },
};

export const getPaymentsNew = async (params: GetPaymentsNewParams) => {
  const response = await apiClient.get<GetPaymentsNewResponse>('/payments/overviews-new', {
    params,
  });

  return response.data;
};
